// extracted by mini-css-extract-plugin
module.exports = {" _key":"dojo2-todo-mvc-kitchensink/App","todoapp":"App-m__todoapp__15fPw"};